import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import NavBar, { darkModeAtom, lensAtom } from './components/NavBar';
import { atom, useAtomValue, useSetAtom } from 'jotai';
import { getLens } from './helpers/LensMapping';
import { Box } from '@mui/material';
import React from 'react';
import ProjectsAPI from './apis/ProjectsAPI';
import { Project } from './entities/ProjectEntity';


export const projectsAtom = atom<Project[] | null>(null);

function App() {
  const lens = useAtomValue(lensAtom);
  const darkMode = useAtomValue(darkModeAtom);
  const setProjects = useSetAtom(projectsAtom);

  React.useEffect(() => {
    ProjectsAPI.getProjects().then((data) => { setProjects(data) });
  }, []);


  const darkTheme = createTheme({
    palette: {
      mode: darkMode ? 'dark' : 'light',
      primary: {
        main: '#777777',
      },
      secondary: {
        main: '#e53935',
      },
      error: {
        main: '#d32f2f',
      },
      background: {
        default: darkMode ? '#121212' : '#e2e0e0',
        paper: darkMode ? '#121212' : '#fff',
      },
    },
    typography: {
      body1: {
        
      }
    }
  });

  return (
    <div className="App">
      <ThemeProvider theme={darkTheme}>
        <CssBaseline />
        <NavBar />
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginY: '1em' }}>
          <Box sx={{ width: '90%' }}>
            {
              getLens(lens)
            }
          </Box>
        </Box>
      </ThemeProvider>
    </div>
  );
}

export default App;
